import { useNavigate, useParams } from 'react-router-dom'

import {
  ClassDocumentsNewFileModalCreateTrainingClassFileDocument,
  TrainingClassDocumentsDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import type { FileSubmissionData } from 'modules/trainings/components/Files/NewFileModal/types'

export default function ClassDocumentsNewFileModal() {
  const navigate = useNavigate()
  const { classId, id } = useParams<{ id: string; classId: string }>()
  const { navigation } = useNavigation()
  const { access } = useCurrentSession()

  const [createDocument] = useMutation(ClassDocumentsNewFileModalCreateTrainingClassFileDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingClassFile,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingClassDocumentsDocument],
  })

  function navigateBack() {
    navigate(
      navigation.trainings.list.details_revamp.view.trainingClasses.detail.documents.fullPath({
        id: String(id),
        classId: String(classId),
      })
    )
  }

  return (
    <NewFileModal
      onSubmit={async (data: FileSubmissionData) => {
        const variables = {
          trainingClassId: String(classId),
          authorId: access.id,
          visibility: false,
          title: data.title,
          file: data.type === 'file' ? data.file : undefined,
          signedId: data.type === 'signedId' ? data.signedId : undefined,
        }
        const result = await createDocument({ variables })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.trainings_files_modal.create_error'),
          })
        })
        if (handled.success) {
          navigateBack()
        }
      }}
      onClose={navigateBack}
      resourceType="Trainings::TrainingClass"
      resourceId={classId}
      title={i18n.t('trainings.trainings_revamp.classes.documents.new_file_modal.title')}
      description={i18n.t(
        'trainings.trainings_revamp.classes.documents.new_file_modal.description'
      )}
    />
  )
}
